export function setPageScrollEnabled(enabled: boolean) {
	document.getElementsByTagName('html')[0].style.overflow = enabled
		? 'initial'
		: 'hidden';
}

export function exclude<T>(arr: T[], item: T): T[] {
	return arr.filter((x) => x !== item);
}
